import React, { useState } from 'react';
import { verifyParticipant } from '../api/appointment';

function Step1Form({ formData, handleInputChange, nextStep }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

const handleVerify = async () => {
  setError(null);

  if (!formData.kodePeserta?.trim()) {
    setError('Kode peserta wajib diisi.');
    return;
  }

  if (!formData.noPeserta?.trim()) {
    setError('Nomor peserta wajib diisi.');
    return;
  }

  setLoading(true);

  try {
    const res = await verifyParticipant({
      kode_peserta: formData.kodePeserta,
      nomor_peserta: formData.noPeserta,
    });
    console.trace("Request API Detail dipicu!");

    if (res.status === true) {
      localStorage.setItem('token_participant', res.data.token);
      nextStep();
    } else {
      setError(res.error || res.msg || 'Verifikasi gagal.');
    }
  } catch (err) {
    setError(
      err?.response?.data?.error ||
      err?.response?.data?.msg ||
      'Terjadi kesalahan pada server. Silakan coba lagi.'
    );
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="step-content active">
       {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          backdropFilter: 'blur(2px)'
        }}>
          <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          {/* <p className="mt-3 fw-bold text-primary">Mohon tunggu sebentar...</p> */}
        </div>
      )}
      
      <h5 className="card-booking-title">Verifikasi Peserta</h5>

      <div className="mb-3">
        <label className="form-label">Kode Peserta Anda</label>
        <input
          type="tel"
          className="form-control"
          name="kodePeserta"
          value={formData.kodePeserta}
          onChange={handleInputChange}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Nomor Peserta Anda</label>
        <input
          type="tel"
          className="form-control"
          name="noPeserta"
          value={formData.noPeserta}
          onChange={handleInputChange}
        />
      </div>

      {/* 🟥 ERROR MESSAGE */}
      {error && (
        <div className="alert alert-danger mt-2">
          {error}
        </div>
      )}

      <div className="d-flex justify-content-end mt-3">
        <button
          type="button"
          className="btn btn-primary btn-footer"
          onClick={handleVerify}
          disabled={loading}
        >
          {loading ? 'Memverifikasi...' : 'Lanjut'}
        </button>
      </div>
    </div>
  );
}

export default Step1Form;
